import { render, staticRenderFns } from "./editComplaintTypeList.vue?vue&type=template&id=df847350&scoped=true"
import script from "./editComplaintTypeList.vue?vue&type=script&lang=js"
export * from "./editComplaintTypeList.vue?vue&type=script&lang=js"
import style0 from "./editComplaintTypeList.vue?vue&type=style&index=0&id=df847350&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df847350",
  null
  
)

export default component.exports